// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CollaborationAccessRequestState {
  Declined = -1,
  Accepted = 0,
  Active = 1,
  Inactive = 2,
}
